import React from 'react';

type State = { hasError: boolean; message?: string };

export class ErrorBoundary extends React.Component<React.PropsWithChildren<{}>, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(error: any): State {
    return { hasError: true, message: error?.message || 'Unknown error' };
  }

  componentDidCatch(error: any, info: any) {
    // eslint-disable-next-line no-console
    console.error('App crashed:', error, info);
  }

  handleReset = () => {
    try { localStorage.clear(); } catch {}
    try { sessionStorage.clear(); } catch {}
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children as any;
    return (
      <div style={{padding:20, maxWidth:720, margin:'10vh auto', fontFamily:'system-ui, -apple-system, Segoe UI, Roboto, sans-serif'}}>
        <h1 style={{marginBottom:8}}>Something went wrong</h1>
        <p style={{color:'#666'}}>The application failed to load. You can try resetting local data and reloading.</p>
        {this.state.message ? <pre style={{background:'#f6f8fa', padding:12, borderRadius:6, overflowX:'auto'}}>{this.state.message}</pre> : null}
        <div style={{marginTop:16}}>
          <button onClick={this.handleReset} style={{padding:'8px 12px'}}>Reset and reload</button>
        </div>
      </div>
    );
  }
}
